import { gql } from '@apollo/client';

export const GET_PROTECTION_PLANS = gql`
  query GetProtectionPlans {
    protectionPlans {
      id
      plan
      dailyPrice
      outOfPocket
      isDailyProtectionPlanDeclinable
      isMonthlyProtectionPlanDeclinable
      declinedProtectionOutOfPocketAmt
      declinedProtectionOutOfPocketPercent
      description
      isActive
      policyDetails
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_PROTECTION_PLAN = gql`
  mutation CreateProtectionPlan($input: CreateProtectionPlanInput!) {
    createProtectionPlan(input: $input) {
      id
      plan
      dailyPrice
      outOfPocket
      isDailyProtectionPlanDeclinable
      isMonthlyProtectionPlanDeclinable
      declinedProtectionOutOfPocketAmt
      declinedProtectionOutOfPocketPercent
      description
      isActive
      policyDetails
      updatedAt
    }
  }
`;

export const UPDATE_PROTECTION_PLAN = gql`
  mutation UpdateProtectionPlan($input: UpdateProtectionPlanInput!) {
    updateProtectionPlan(input: $input) {
      id
      plan
      dailyPrice
      outOfPocket
      isDailyProtectionPlanDeclinable
      isMonthlyProtectionPlanDeclinable
      declinedProtectionOutOfPocketAmt
      declinedProtectionOutOfPocketPercent
      description
      isActive
      policyDetails
      createdAt
      updatedAt
    }
  }
`;

export const GET_PROTECTION_PLANS_BY_USER_ID = gql`
  query GetProtectionPlansByUserId($userId: String!) {
    protectionPlansByUserId(userId: $userId) {
      id
      plan
      dailyPrice
      outOfPocket
      isDailyProtectionPlanDeclinable
      isMonthlyProtectionPlanDeclinable
      declinedProtectionOutOfPocketAmt
      declinedProtectionOutOfPocketPercent
      isActive
      policyDetails
      description
      createdAt
      updatedAt
    }
  }
`;

export const GET_PROTECTION_PLAN_BY_ID = gql`
  query GetProtectionPlanById($id: String!) {
    protectionPlan(id: $id) {
      id
      plan
      dailyPrice
      outOfPocket
      isDailyProtectionPlanDeclinable
      isMonthlyProtectionPlanDeclinable
      declinedProtectionOutOfPocketAmt
      declinedProtectionOutOfPocketPercent
      description
      isActive
      policyDetails
      createdAt
      updatedAt
    }
  }
`;
